import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createNativeAppTicketFn } from '../../lib/api';
import { Spinner } from '../Spinner';

export const NATIVE_APP_QUERY_KEY = 'native_app';
export const CRATE_VIDEO_UPSCALER_CLIENT = 'crates-video-upscaler';

export const getNativeAppClient = (searchParams) => {
  const client = searchParams?.get?.(NATIVE_APP_QUERY_KEY);

  return client === CRATE_VIDEO_UPSCALER_CLIENT ? client : null;
};

const cleanNativeAppFromUrl = () => {
  const currentUrl = new URL(window.location.href);
  if (!currentUrl.searchParams.has(NATIVE_APP_QUERY_KEY)) {
    return;
  }

  currentUrl.searchParams.delete(NATIVE_APP_QUERY_KEY);
  window.history.replaceState({}, document.title, `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
};

const NativeAppHandoff = ({ client }) => {
  const launchAttemptedRef = useRef(false);
  const [callbackUrl, setCallbackUrl] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const requestTicket = useCallback(async () => {
    setError(null);
    setIsLoading(true);

    try {
      const response = await createNativeAppTicketFn(client);
      const nextCallbackUrl = response?.callback_url;
      if (typeof nextCallbackUrl !== 'string' || !nextCallbackUrl.trim()) {
        throw new Error('Missing native app callback URL.');
      }

      setCallbackUrl(nextCallbackUrl);
      cleanNativeAppFromUrl();
      window.location.assign(nextCallbackUrl);
    } catch (requestError) {
      setError('We could not open Crate Video Upscaler. Please try again.');
    } finally {
      setIsLoading(false);
    }
  }, [client]);

  useEffect(() => {
    if (launchAttemptedRef.current) {
      return;
    }

    launchAttemptedRef.current = true;
    requestTicket();
  }, [requestTicket]);

  const openApp = () => {
    if (callbackUrl) {
      window.location.assign(callbackUrl);
      return;
    }

    requestTicket();
  };

  return (
    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', minHeight: '100vh', padding: '24px', background: '#111217', color: '#F4F4F4'}}>
      <div style={{width: '100%', maxWidth: '540px', padding: '32px', borderRadius: '18px', border: '1px solid #2A2D39', background: '#1B1C24', textAlign: 'center'}}>
        {isLoading && <Spinner style={{position: 'relative', marginBottom: '16px'}} />}
        <h1 style={{margin: '0 0 12px'}}>Opening Crate Video Upscaler</h1>
        <p style={{margin: '0 0 20px', color: '#C7C9D3'}}>Your account is ready. Continue in the app.</p>
        {error && <p style={{margin: '0 0 16px', color: '#F7B3A8'}}>{error}</p>}
        <button type="button" onClick={openApp} disabled={isLoading} style={{border: 0, borderRadius: '10px', padding: '13px 20px', cursor: isLoading ? 'wait' : 'pointer', background: '#F36C17', color: '#FFFFFF', fontSize: '16px', fontWeight: 700}}>
          Open Crate Video Upscaler
        </button>
      </div>
    </div>
  );
};

export default NativeAppHandoff;
